import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import * as serviceWorker from './serviceWorker';
import { msalConfig } from './msalConfig';
import { App } from './App';
import { ChakraProvider} from '@chakra-ui/react';
import { UICLThemeProvider } from '@uhg-uicl/ui-core/dist';
import { fonts } from './fonts';

const msalInstance = new PublicClientApplication(msalConfig);


export const loadFonts = () => {
  const head = document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.innerHTML = fonts;
  head.appendChild(style);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ChakraProvider>
        <UICLThemeProvider theme="dark">
          <App />
        </UICLThemeProvider>
      </ChakraProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
